import React from 'react';
import createSvgIcon from "@/lib/vendor/@material-ui/icons/src/utils/createSvgIcon";

export default createSvgIcon(
  <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />,
  "CheckBoxOutlineBlank"
);
